import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Globe from '../icons/Globe';
export const Favicon = ({ domain, size = 24, ...props }) => {
    const [renderImage, setRenderImage] = React.useState(() => Boolean(domain));
    const onError = () => setRenderImage(false);
    return renderImage ? (_jsx("img", { width: size, height: size, src: `https://icons.duckduckgo.com/ip3/${domain}.ico`, alt: `${domain}'s favicon`, onError: onError, loading: "lazy", ...props })) : (_jsx(Globe, { width: size, height: size, ...props }));
};
